module.exports = {"130283001":"永顺街道","130283002":"兴安街道","130283003":"滨河街道","130283004":"杨店子街道","130283101":"夏官营镇","130283102":"杨各庄镇","130283103":"建昌营镇","130283104":"赵店子镇","130283105":"野鸡坨镇","130283106":"大崔庄镇","130283108":"蔡园镇","130283109":"马兰庄镇","130283110":"沙河驿镇","130283111":"木厂口镇","130283112":"上射雁庄镇","130283113":"太平庄镇","130283114":"扣庄镇","130283115":"大五里镇","130283116":"五重安镇","130283117":"彭店子镇","130283118":"阎家店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130283.json
// module id = 183
// module chunks = 0